import styled from 'styled-components/macro';

export const TextContainer = styled.div<{ disabled?: boolean }>`
  border: 0.066rem solid ${({ disabled, theme }) => (disabled ? theme.bg4 : theme.bg6)};
  border-radius: 0.5rem;
`;
